import { request } from "../client"

export type ContactPolicyTemplatePreviewPayload = {
  channel: ContactChannel
  customer_id: string
  template_body?: string | null
  template_subject?: string | null
  address_window?: Record<string, number> | null
}

export type ContactPolicyTemplatePreview = {
  channel: ContactChannel
  subject?: string | null
  body_text: string
  body_html?: string | null
  document_base64?: string | null
  document_mime_type?: string | null
  target_value?: string | null
  public_link?: string | null
  organization_name?: string | null
  property_address?: string | null
  customer_name?: string | null
  template_body?: string | null
  template_subject?: string | null
  generated_at: string
}

export const fetchContactPolicy = (organizationId: string) =>
  request<OrganizationContactPolicy>(`/contact-policy/${organizationId}`)

export const updateContactPolicy = (
  organizationId: string,
  payload: OrganizationContactPolicyUpdatePayload,
) =>
  request<OrganizationContactPolicy>(`/contact-policy/${organizationId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  })

export const uploadLetterSignaturePhoto = (organizationId: string, file: File) => {
  const body = new FormData()
  body.append("file", file)

  return request<OrganizationContactPolicy>(
    `/contact-policy/${organizationId}/letter-signature/photo`,
    {
      method: "POST",
      body,
    },
  )
}

export type LetterSignaturePhotoPreview = {
  image_base64: string
  width: number
  height: number
}

/** Extract a signature into a local draft without changing the contact policy. */
export const previewLetterSignaturePhoto = (organizationId: string, file: File) => {
  const body = new FormData()
  body.append("file", file)

  return request<LetterSignaturePhotoPreview>(
    `/contact-policy/${organizationId}/letter-signature/photo/preview`,
    { method: "POST", body },
  )
}

export const previewContactPolicyTemplate = (
  organizationId: string,
  payload: ContactPolicyTemplatePreviewPayload,
) =>
  request<ContactPolicyTemplatePreview>(`/contact-policy/${organizationId}/template-preview`, {
    method: "POST",
    body: JSON.stringify(payload),
  })
